import Reveal from "@/components/base/Reveal";
import { themes } from "@/mocks/drama";

export default function Themes() {
  return (
    <section id="themes" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg">
            <div className="h-56 w-full md:h-72">
              <img
                src="https://readdy.ai/api/search-image?query=Moody%20artistic%20photograph%20of%20a%20winding%20stone%20staircase%20fading%20into%20warm%20golden%20light%20at%20the%20end%2C%20dramatic%20chiaroscuro%20with%20deep%20shadow%2C%20subtle%20crimson%20accents%2C%20mysterious%20conceptual%20cinematic%20style%2C%20textured%20aged%20walls%2C%20no%20people&width=1400&height=700&seq=drama-stairway-light&orientation=landscape"
                alt="幽暗石质旋梯尽头透出暖金色光，象征欲望尽头仍在追寻的方向"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/20" />
            <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-12">
              <p className="flex items-center gap-2 font-label text-sm tracking-[0.3em] text-accent-400">
                <i className="ri-compasses-2-line" />
                主 题 解 读
              </p>
              <h2 className="mt-4 max-w-xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                欲望这条线，为什么很难评判对错
              </h2>
              <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-100/85 md:text-base">
                剧集始终避免非黑即白。它更想让我们看到：每一个选择背后，都站着一个自认为有理由的人。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {themes.map((theme, idx) => (
            <Reveal key={theme.title} delay={idx * 55}>
              <article className="flex h-full flex-col rounded-lg border border-background-300 bg-background-50 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-xl text-accent-700">
                  <i className={theme.icon} />
                </span>
                <h3 className="mt-5 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {theme.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {theme.desc}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}